<script lang="ts">
	import type { PublicDay } from '../../AppTypes';

	export let days: PublicDay[] = [];

	const width = 600;
	const height = 120;
	const padding = 8;

	$: points = days
		.map((d, i) => ({ i, value: d.avgResponseTimeMs }))
		.filter((p): p is { i: number; value: number } => p.value !== null);

	$: maxValue = points.length > 0 ? Math.max(...points.map((p) => p.value)) : 0;
	$: span = days.length > 1 ? days.length - 1 : 1;

	function x(i: number): number {
		return padding + (i / span) * (width - 2 * padding);
	}
	function y(value: number): number {
		const max = maxValue > 0 ? maxValue : 1;
		return height - padding - (value / max) * (height - 2 * padding);
	}

	$: linePath = points.map((p, idx) => `${idx === 0 ? 'M' : 'L'} ${x(p.i)} ${y(p.value)}`).join(' ');
	$: areaPath =
		points.length > 0
			? `${linePath} L ${x(points[points.length - 1].i)} ${height - padding} L ${x(points[0].i)} ${height - padding} Z`
			: '';
</script>

{#if points.length > 1}
	<svg viewBox={`0 0 ${width} ${height}`} class="w-full h-28" preserveAspectRatio="none">
		<path d={areaPath} fill="#3b82f6" opacity="0.12" />
		<path d={linePath} fill="none" stroke="#3b82f6" stroke-width="2" />
	</svg>
	<div class="flex justify-between text-xs text-gray-400 mt-1">
		<span>{days[0]?.day}</span>
		<span>peak {maxValue} ms</span>
		<span>{days[days.length - 1]?.day}</span>
	</div>
{:else}
	<p class="text-sm text-gray-400 py-6 text-center">No response-time data yet.</p>
{/if}
